module.exports = __webpack_public_path__ + "img/35.0d73b72a.png";